import queryString from 'querystring';

import reduxCreator from '../libs/mk-womanizer/redux-creator';
import axiosPlugin from "../libs/mk-womanizer/ac-axios-plugin";

let redux = reduxCreator.type('USER_FRIENDS_REQUEST').plugin(axiosPlugin, {template: "array"});

let fetchUserFriendsRequestAction = redux.fetchActionGet();

let createUserFriendsRequestAction = redux.fetchActionCreate();

redux.reducerForType('UPDATE', (state,payload) => {
    let newState = {...state};
    if(payload.data && payload.data._id){
        newState.data = newState.data.filter(item => item._id.toString() !== payload.data._id.toString());
        newState.total--;
        if(newState.total < 0){
            newState.total = 0;
        }
    }
    return newState;
});

export const fetchUserFriendsRequest = (userId, query = {}) => fetchUserFriendsRequestAction(`/users/${userId}/answers?${queryString.stringify(query)}`);
export const createUserFriendsRequest = (userId, data = {}) => createUserFriendsRequestAction(`/users/${userId}/answers`, data);
export const resetUserFriendsRequest = () => redux.actions.reset();

export const userFriendsRequest = redux.reducer();